import { Injectable, inject } from '@angular/core';
import { ApiService } from './api.service';

@Injectable({ providedIn: 'root' })
export class PtReservationMenuService {
  private api = inject(ApiService);

  get(id: number) { return this.api.get(`/reservation/menu/${id}`); }
  getAll(studioId: number) { return this.api.get(`/reservation/menu/studio/${studioId}`); }
  upsert(json: any) { return this.api.post('/reservation/menu', json); }
  remove(json: any) { return this.api.post('/reservation/menu/remove', json); }
}
